import { Avatar, Dialog, Size } from '@hourly-hds/components';
import { Mail, Phone, User } from '@hourly-hds/icons/glyph';
import { ReactNode } from 'react';
import Circle from './components/Circle';
import Plus from './components/Plus';
import styles from './ContactUsDialog.module.css';
import { useContactInfo } from './data/hooks/useContactInfo';

const ActionComponent = ({
  icon,
  label,
  link,
}: {
  icon: ReactNode;
  label: string;
  link: string;
}) => (
  <div className={styles.option}>
    {icon}
    <a className={styles.link} href={link} rel="noopener noreferrer" target="_blank">
      {label}
    </a>
  </div>
);

type ContactUsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  partnerId: string;
};

const ContactUsDialog = ({ isOpen, onClose, partnerId }: ContactUsDialogProps) => {
  const { contact } = useContactInfo(partnerId ?? '');

  if (!contact) return null;

  return (
    <div className={styles.overlayWrapper}>
      <Dialog onClose={onClose} open={isOpen} size={Size.ExtraLarge}>
        <Dialog.Header>
          <div className={styles.headerContent}>
            <div className={styles.decorationContainer}>
              <Circle className={styles.circleIconLg} />
              <Plus className={styles.plusLgDark} />
            </div>
            <h1>Support Contacts</h1>
          </div>
        </Dialog.Header>

        <Dialog.Content>
          <div className={styles.dialogContent}>
            <div className={styles.avatarContainer}>
              <Avatar size="large" fallback={<User />} />
              <div className={styles.avatarDescription}>
                <h3>{contact.name}</h3>
                <span>Territory Sales Manager</span>
              </div>
            </div>
            <div className={styles.optionsContainer}>
              <ActionComponent
                label={contact.email}
                icon={<Mail className={styles.linkIcon} />}
                link={`mailto:${contact.email}`}
              />
              <ActionComponent
                label={contact.phoneNumberFormatted}
                icon={<Phone className={styles.linkIcon} />}
                link={`tel:+1${contact.phoneNumber}`}
              />
            </div>
          </div>
        </Dialog.Content>
      </Dialog>
    </div>
  );
};

export default ContactUsDialog;
